import { render, staticRenderFns } from "./Avintercomsplay.vue?vue&type=template&id=adece228&scoped=true&"
import script from "./Avintercomsplay.vue?vue&type=script&lang=js&"
export * from "./Avintercomsplay.vue?vue&type=script&lang=js&"
import style0 from "./Avintercomsplay.vue?vue&type=style&index=0&id=adece228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adece228",
  null
  
)

export default component.exports